import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSolutionJson, setUserParam } from '../../../actions';
import { StyledSelectInput } from '../../Wizard/Global/WizardStyled';
import { isProdEnv } from '../../../utils/helpers';
import withTranslation from '../../../hoc/withTranslation';
import { APP_MODES, getAppMode } from '../../../utils/urlHelpers';
import config from '../../../config';

const isProd = isProdEnv();
const showCustom = getAppMode().includes(APP_MODES.CUSTOM_URL);

const TpaSelector = ({ user, disabled, translations }) => {
  const {
    menu: { customOption, disabledRequestTypeInfo },
  } = translations;
  const dispatch = useDispatch();
  const usageContext = useSelector(({ usageContext: stateUsageContext }) => stateUsageContext);
  const solution = useSelector(({ solution: stateSolution }) => stateSolution);

  const handleSetUserParam = useCallback(
    (version) => dispatch(setUserParam({ tpaVersion: { ...user.tpaVersion, version } })),
    [dispatch, user.tpaVersion],
  );
  const handleSetSolutionJson = useCallback(
    (param) => dispatch(setSolutionJson(param)),
    [dispatch],
  );

  useEffect(() => {
    if (isProd && user.tpaVersion.version !== 'prod') {
      handleSetUserParam('prod');
    }
  }, [user.tpaVersion.version, handleSetUserParam]);

  const onChange = useCallback(
    (e) => {
      handleSetUserParam(e.target.value);
      if (e.target.value !== 'custom' && solution.json && usageContext.currentStep !== 1)
        handleSetSolutionJson({ jsonUserChange: true });
    },
    [handleSetUserParam, handleSetSolutionJson, solution.json, usageContext.currentStep],
  );

  const options = [
    ...Object.entries(config.tpaVersions).map(([key, { label }]) => ({
      value: key,
      label,
      show: key === 'prod' ? true : !isProd,
    })),
    { value: 'custom', label: customOption, show: !isProd || showCustom },
  ];

  return (
    <StyledSelectInput
      data-testid="tpVersionDropdown"
      contrast
      sizeL
      onChange={isProd ? undefined : onChange}
      value={user.tpaVersion.version}
      disabled={disabled || isProd}
      title={disabled ? disabledRequestTypeInfo : undefined}
      style={isProd ? { pointerEvents: 'none', userSelect: 'text' } : undefined}
    >
      {options.map(
        (option) =>
          option.show && (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ),
      )}
    </StyledSelectInput>
  );
};

export default withTranslation(TpaSelector);
